var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import SyncModal from "./syncModal";
class Implementations extends PureComponent {
    constructor(props) {
        super(props);
        console.log("Implementations Props: ", props);
        this.fetchImplementations = this.fetchImplementations.bind(this);
        this.renderImplementationDropDown =
            this.renderImplementationDropDown.bind(this);
        this.fetchTestStreamResult = this.fetchTestStreamResult.bind(this);
        this.onImplementationChange = this.onImplementationChange.bind(this);
        this.testStream = this.testStream.bind(this);
        this.state = {
            streams: {},
            loading: true,
            currentStream: {
                AvailableImplementations: [],
                dbValue: { implementationClass: "" },
                CurrentImplementation: "",
            },
            streamKeys: [],
            streamTestResult: {},
            isStreamTesting: false,
        };
        this.fetchImplementations();
    }
    onImplementationChange(key, event) {
        return __awaiter(this, void 0, void 0, function* () {
            const stream = key;
            const impl = event.target.value;
            console.log("Saving Implementation");
            const saveResult = yield fetch("/aviso/connectorConfiguration/saveConfigurationImplementation", {
                method: "POST",
                credentials: "include",
                body: JSON.stringify({
                    selectedImplementation: impl,
                    streamName: stream,
                    properties: {},
                }),
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then((response) => response.json())
                .catch((err) => console.log(err));
            console.log("/aviso/connectorConfiguration/saveConfigurationImplementation", saveResult);
            window.location.reload();
        });
    }
    fetchImplementations() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch("/aviso/connectorConfiguration/fetchStreamInfo", {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const result = yield response.json();
            const streams = JSON.parse(result.streams.content);
            // @ts-expect-error - TS7034 - Variable 'streamKeys' implicitly has type 'any[]' in some locations where its type cannot be determined.
            const streamKeys = [];
            Object.keys(streams).forEach((x) => {
                streamKeys.push(x);
                // @ts-expect-error - TS7006 - Parameter 'z' implicitly has an 'any' type.
                streams[x].dbValue = result.values.find((z) => z.streamName === x);
                streams[x].value = streams[x].dbValue
                    ? streams[x].dbValue.implementationClass
                    : "";
                streams[x].inSync = true;
                if (streams[x].dbValue) {
                    streams[x].inSync =
                        streams[x].dbValue.implementationClass ===
                            streams[x].CurrentImplementation;
                }
                else {
                    streams[x].dbValue = { implementationClass: "No Set Value" };
                    streams[x].value = streams[x].CurrentImplementation;
                }
            });
            console.log("/aviso/connectorConfiguration/fetchStreamInfo", result);
            // @ts-expect-error - TS7005 - Variable 'streamKeys' implicitly has an 'any[]' type.
            this.setState({ streams, loading: false, streamKeys: streamKeys.sort() });
        });
    }
    fetchTestStreamResult(streamName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield fetch(`/aviso/connectorConfiguration/test?streamName=${streamName}`, {
                    method: "GET",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                console.log(response);
                if (!response.ok) {
                    throw response.statusText;
                }
                const result = yield response.json();
                console.log(`/aviso/connectorConfiguration/testStream?streamName=${streamName}`, result);
                this.setState({ isStreamTesting: false, streamTestResult: result });
            }
            catch (ex) {
                this.setState({
                    isStreamTesting: false,
                    streamTestResult: { er: { success: false, ex } },
                });
            }
        });
    }
    setCurrentStream(stream) {
        this.setState({
            currentStream: stream,
            isStreamTesting: false,
            streamTestResult: {},
        });
    }
    testStream(key) {
        this.setState({
            currentStream: this.state.streams[key],
            isStreamTesting: true,
        });
        this.fetchTestStreamResult(key);
    }
    renderImplementationDropDown(key, stream, baseImplt) {
        return (_jsxs("select", { className: "form-control", onChange: (event) => this.onImplementationChange(key, event), 
            // @ts-expect-error - TS2339 - Property 'inSync' does not exist on type 'Stream'.
            style: { color: stream.inSync ? "green" : "red" }, 
            // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'Stream'.
            value: stream.value || baseImplt, children: [_jsx("option", { value: "" }), _jsx("option", { value: baseImplt, children: baseImplt }), stream.AvailableImplementations.map((ai) => (_jsx("option", { value: ai, children: ai }, ai)))] }));
    }
    renderSync(item) {
        if (item.inSync) {
            return (_jsx("i", { "aria-hidden": "true", className: "fa fa-fw fa-refresh text-success" }));
        }
        return _jsx("i", { "aria-hidden": "true", className: "fa fa-fw fa-refresh text-danger" });
    }
    render() {
        if (this.state.loading) {
            return (_jsx("div", { className: "row justify-content-center align-items-center", children: _jsx("div", { className: "col-auto", children: _jsx("i", { className: "center-block fal fa-circle-notch fa-spin fa-3x fa-fw" }) }) }));
        }
        return (_jsxs("div", { children: [_jsx("div", { className: "form-group", children: this.state.streamKeys.map((key) => (_jsxs("div", { className: "row", children: [_jsx("div", { className: "col-sm-3", children: _jsxs("div", { className: "row", "data-target": "#syncModal", "data-toggle": "modal", onClick: () => this.setCurrentStream(this.state.streams[key]), children: [_jsx("div", { className: "col-1", children: this.renderSync(this.state.streams[key]) }), _jsx("div", { className: "col-11", children: key.replace(/^./, (str) => str.toUpperCase()).trim() })] }) }), _jsx("div", { className: "col-sm-7", children: this.renderImplementationDropDown(key, this.state.streams[key], this.state.streams[key].BaseImplementation) }), _jsxs("div", { className: "col-sm-2", children: [_jsx("div", { className: "col-sm-6", children: _jsx(Link, { to: `/aviso/app/admin/connectorConfiguration/configure/${key}/${this.state.streams[key].value}`, children: _jsx("button", { className: "btn btn-primary center-block", type: "button", children: _jsx("i", { "aria-hidden": "true", className: "fa fa-wrench" }) }) }) }), _jsx("div", { className: "col-sm-6", "data-target": "#syncModal", "data-toggle": "modal", onClick: () => this.testStream(key), children: _jsx("button", { className: "btn btn-success center-block", type: "button", children: _jsx("i", { "aria-hidden": "true", className: "fa fa-cogs" }) }) })] })] }, key))) }), _jsx(SyncModal, { connectorValue: this.state.currentStream.CurrentImplementation, data: this.state.streamTestResult, dbValue: this.state.currentStream.dbValue.implementationClass, header: "Current Values", id: "syncModal", isDataLoading: this.state.isStreamTesting })] }));
    }
}
export default Implementations;
